import { render } from "./Tab1.vue?vue&type=template&id=2419543d&scoped=true&ts=true"
import script from "./Tab1.vue?vue&type=script&lang=ts"
export * from "./Tab1.vue?vue&type=script&lang=ts"

import "./Tab1.vue?vue&type=style&index=0&id=2419543d&scoped=true&lang=css"

import exportComponent from "/Users/michael/Sites/firegui_multilink_app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2419543d"]])

export default __exports__